<div *ngFor="let dataGroup of chatdata.metadata;" class="row">

    <div *ngFor="let data of dataGroup| keys let i = index" class="col-6 display-grid m-b-15">
        <div>
            <div class="product-panel__bg1">
                <div class="product_panel">
                    <h4 *ngIf="data.query_title && data.query_title !== ''">
                        {{data.query_title | slice:0:62}}{{data.query_title.length > 62 ? '...' : '' }}
                    </h4>
                </div>
                <div class="product_panel_body">
                    <p class="p-b-10" *ngIf="data.rtq_id && data.rtq_id !== '' && data.rtq_id !== null">
                        <span>RTQ ID:
                            <a [href]="configdata.FusionAppUIUrl + '/rtq?modulePath=/rtqs/view-rtq&id=' + data.rtq_id"
                                target="_blank">
                                {{data.rtq_id}}
                            </a>
                        </span>
                    </p>
                    <p class="p-b-10" *ngIf="data.product_id && data.product_id !== ''">
                        <span>Product ID: {{data.product_id}}</span>
                    </p>
                    <p class="p-b-10"
                        *ngIf="data.productName && data.productName !== '' && data.productName !== null">
                        <span>Product: {{data.productName}}</span>
                    </p>
                    <p class="p-b-10" *ngIf="data.document_id">
                        <span>
                          Document ID:
                          <a href="#" (click)="downloadDocument(data.document_id); $event.preventDefault()">
                            {{ data.document_id }}
                          </a>
                        </span>
                      </p>
                    <p class="p-b-10" *ngIf="data.Country && data.Country !== '' && data.Country !== null">
                        <span>Country: {{data.Country}}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>